import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          footer: {
            subscriptionHeading: "Contact us for cooperation",
            inputPlaceholder: "Your Email",
            aboutUs: "About Us",
            contactUs: "Contact Us",
            videos: "Videos",
            socialMedia: "Social Media",
            howItWorks: "How it works",
            testimonials: "Testimonials",
            careers: "Careers",
            investors: "Investors",
            termsOfService: "Terms of Service",
            contact: "Contact",
            support: "Support",
            destinations: "Destinations",
            sponsorships: "Sponsorships",
            submitVideo: "Submit Video",
            ammbassadors: "Ammbassadors",
            agency: "Agency",
            influencer: "Influencer",
            instagram: "Instagram",
            facebook: "Facebook",
            linkedin: "LinkedIn",
            twitter: "Twitter",
            websiteRights: "Design by MIDENAS © 2022",
          },
          cards: {
            cardClientTitle: "Client First",
            cardClientShort:
              "For any business, Clients are always at the core. Being a leading developer of web and mobile applications",
            cardClientDesc:
              "For any business, Clients are always at the core. Being a leading developer of web and mobile applications, our concept goes beyond our direct customers.We always start from where you are with your ideas and we think from the viewpoints of your end users, their areas of pain, and formulate a solution that solves key issues to help your business.",
            cardStrongExpertiseTitle: "Strong Expertise",
            cardStrongExpertiseShort:
              "So you can expect a greater level of ownership, commitments & deliveries in less time with higher quality while following all the best practices.",
            cardStrongExpertiseDesc:
              "So you can expect a greater level of ownership, commitments & deliveries in less time with higher quality while following all the best practices for the development. Thereby providing the best values for our customers. It is always that we believe in Quality > Quantity & “Value” is what is valued.",
            cardDeliveryOnTimeTitle: "On Time Delivery",
            cardDeliveryOnTimeShort:
              "We have a great collection of internal frameworks with best-in-class infrastructure with a decade of experience in the IT software development industry.",
            cardDeliveryOnTimeDesc:
              "We have a great collection of internal frameworks with best-in-class infrastructure with a decade of experience in the IT software development industry that helps us to deliver solutions with superior quality at all times. We have learned how to avoid mistakes and repeat success all these years. We don't brag about consistency alone. In time, we describe and produce it. Our Products are here to notify the same.",
            showMore: "Show more",
          },
          homePage: {
            technologyExpirience: "Technology experience",
            javaScript: "JavaScript",
            java: "Java",
            typeScript: "TypeScript",
            react: "React",
            webServices: "Web Services",
            webApplication: "Web Application",
            webDesign: "Web Design",
            customSoftware: "Custom Software",
            angular: "Angular",
            design: "Design",
            cSharp: "C#",
            dotNet: ".NET",
            database: "Database",
            reactTitle: "React",
            nodeJs: "Node.js",
            reactGeneral:
              "React is a free and open-source front-end JavaScript library for building user interfaces based on UI components. It is maintained by Meta and a community of individual developers and companies.",
            reactUsedForTitle: "What is React used for?",
            reactUsedForText:
              "React. js is an open-source JavaScript library that is used for building user interfaces specifically for single-page applications. It's used for handling the view layer for web and mobile apps. React also allows us to create reusable UI components.",
            reactProgrammingTitle: "What is React in programming?",
            reactProgrammingText:
              "React is a declarative, efficient, and flexible JavaScript library for building user interfaces. It lets you compose complex UIs from small and isolated pieces of code called “components”.",
            javaScriptTitle: "JavaScript",
            javaScriptGeneral:
              "JavaScript, often known as JS, is a programming language that is one of the core technologies of the World Wide Web, alongside HTML and CSS. Over 97% of websites use JavaScript on the client side for web page behavior, often incorporating third-party libraries.",
            javaScriptUsedForTitle: "What JavaScript is used for?",
            javaScriptUsedForText:
              "Javascript is used by programmers across the world to create dynamic and interactive web content like applications and browsers. JavaScript is so popular that it's the most used programming language in the world, used as a client-side programming language by 97.0% of all websites.",
            javaScriptEasyToLearnTitle: "Is JavaScript easy to learn?",
            javaScriptEasyToLearnText:
              "JavaScript is a simple and easy-to-learn programming language as compared to other languages such as C++, Ruby, and Python. It is a high-level, interpreted language that can easily be embedded with languages like HTML.",
            typeScriptTitle: "TypeScript",
            typeScriptGeneral:
              "TypeScript is a programming language developed and maintained by Microsoft. It is a strict syntactical superset of JavaScript and adds optional static typing to the language. It is designed for the development of large applications and transpiles to JavaScript.",
            typeScriptUsedForTitle: "What is TypeScript used for?",
            typeScriptUsedForText:
              "TypeScript simplifies JavaScript code, making it easier to read and debug. TypeScript is open source. TypeScript provides highly productive development tools for JavaScript IDEs and practices, like static checking. TypeScript makes code easier to read and understand.",
            typeScriptFrontOrBackTitle: "Is TypeScript frontend or backend?",
            typeScriptFrontOrBackText:
              "TypeScript is a natural fit for the world of frontend applications. With its rich support for JSX and its ability to safely model mutability, TypeScript lends structure and safety to your application and makes it easier to write correct, maintainable code in the fast-paced environment that is frontend development.",
            webServicesTitle: "Web Services",
            webServicesGeneral:
              "A Web service is a method of communication between two electronic devices over a network. It is a software function provided at a network address over the Web with the service always-on as in the concept of utility computing. Many organizations use multiple software systems for management.",
            webServicesIsGoogleWebServiceTitle: "Is Google a web service?",
            webServicesIsGoogleWebServiceText:
              "Google.com is a well-known web search engine. Google has made a web service available that allows developers to interface with their search engine within their own applications. A user can search for any topic on the web. A query will return data about the web pages that are found.",
            webServicesWhichLanguageTitle:
              "Which language is best for web services?",
            webServicesWhichLanguageText:
              "JavaScript. There is no doubt that JavaScript is the King of web development and probably the most popular language among web developers. It's also the only language that allows you to create web applications, both frontend, and backend as well as mobile applications (React Native).",
            webApplicationTitle: "Web Application",
            webApplicationExampleTitle:
              "What is an example of a web application?",
            webApplicationExampleText:
              "Example of popular web applications include Google Apps and Microsoft 365. Google Apps for Work has Gmail, Google Docs, Google Sheets, Google Slides, online storage and more. Other functionalities include online sharing of documents and calendars",
            webApplicationBegginersTitle:
              "What is a web application for beginners?",
            webApplicationBegginersText:
              "A web application is an application that's developed using web technologies. It's usually executed in a web browser by going to a specific URL. I'm saying usually executed because in some use cases developers utilize wrappers.",
            webApplicationYouTubeTitle: "Is YouTube a web application?",
            webApplicationYouTubeText:
              "Web applications are websites with functionality and interactive elements. Gmail, Facebook, YouTube, Twitter, etc. are all web apps that are dynamic, and built for user engagement.",
            webDesignTitle: "Web Design",
            webDesignWhatDesignerBeginnerDoTitle:
              "What does a web designer do?",
            webDesignWhatDesignerBeginnerDoText:
              "A web designer creates the layout and design of a website. In simple terms, a website designer makes a site look good. They use design programs to create visual elements",
            webDesignWhatDesignerDoTitle: "What does a web designer do?",
            webDesignWhatDesignerDoText:
              "A web designer creates the layout and design of a website. In simple terms, a website designer makes a site look good. They use design programs to create visual elements.",
            webDesignHowFastLearnTitle: "How fast can you learn web design?",
            webDesignHowFastLearnText:
              "It takes around 5 to 6 months to learn web development from scratch. This is if you spend a few hours studying every day. Some people learn in just a few months. However, it takes others a little over a year.",
            customSoftwareTitle: "Custom Software",
            customSoftwareGeneral:
              "Custom software development is the process of designing, creating, deploying and maintaining software for a specific set of users, functions or organizations. In contrast to commercial off-the-shelf software (COTS), custom software development aims at a narrowly defined set of requirements.",
            customSoftwareCustomExamplesTitle: "What is custom and examples?",
            customSoftwareCustomExamplesText:
              "Custom is defined as a tradition or a usual way to behave. An example of custom is Catholics giving up meat on Fridays during Lent. noun. 1. The definition of custom is made or designed specifically for an individual.",
            customSoftwareImportanceTitle:
              "What is the importance of custom software?",
            customSoftwareImportanceText:
              "Custom software is being tailored to fit just your needs no less, no more. It reduces training time and cost. Custom solutions can speed up deployment as well as user adoption. It can fill a niche and optimize your business flow, rather than force you to change processes you already use.",
            angularTitle: "Angular",
            angularGeneral:
              "Angular is a TypeScript-based free and open-source web application framework led by the Angular Team at Google and by a community of individuals and corporations. Angular is a complete rewrite from the same team that built AngularJS.",
            angularUsedForTitle: "What is Angular is used for?",
            angularUsedForText:
              "Angular is a platform and framework for building single-page client applications using HTML and TypeScript. Angular is written in TypeScript. It implements core and optional functionality as a set of TypeScript libraries that you import into your applications.",
            angularFrontOrBackTitle: "Is Angular front or back end?",
            angularFrontOrBackText:
              "Angular is an open-source frontend framework.It is a JavaScript-based TypeScript development language that eliminates unneeded features and code to ensure lighter and faster applications.",
            angularEasyToLearnTitle: "Is Angular easy to learn?",
            angularEasyToLearnText:
              "AngularJS is perfect for Single Page Applications (SPAs). AngularJS is easy to learn.",
            designTitle: "Design",
            designEasyTitle: "Is graphic designing easy?",
            designEasyText:
              "Learning graphic design is not hard, an aptitude towards art and design, and time and dedication. Graphic design requires learning the necessary tools, as well as understanding and applying the principles and theories of design.",
            designWhatDesignerDoTitle: "What do graphic designers do?",
            designWhatDesignerDoText:
              "Graphic designers create visual concepts, using computer software or by hand, to communicate ideas that inspire, inform, and captivate consumers. They develop the overall layout and production design for applications such as advertisements, brochures, magazines, and reports.",
            cSharpTitle: "C#",
            cSharpGeneral:
              "C# is a general-purpose, multi-paradigm programming language. C# encompasses static typing, strong typing, lexically scoped, imperative, declarative, functional, generic, object-oriented, and component-oriented programming disciplines.",
            cSharSimilarJavaTitle: "Is C# similar to Java?",
            cSharSimilarJavaText:
              "C# and Java are similar languages that are typed statically, strongly, and manifestly. Both are object-oriented, and designed with semi-interpretation or runtime just-in-time compilation, and both are curly brace languages, like C and C++.",
            cSharWhatPayMoreTitle: "What pays more Java or C#?",
            cSharWhatPayMoreText:
              "The same methodology applied to Indeed.com/USA shows 60% of Java jobs paying $100k or more compared with 46.5% for C#.",
            cSharDifficultTitle: "Is C# difficult to learn?",
            cSharDifficultText:
              "C# is one of the easiest programming languages to learn. C# is a high-level, general purpose programming language that is easy to read because of its well-defined class hierarchy. It is the perfect language for beginner developers as it will be straightforward to grasp compared to most other languages.",
            dotNetTitle: ".NET",
            dotNetGeneral:
              "The .NET Framework is a proprietary software framework developed by Microsoft that runs primarily on Microsoft Windows. It was the predominant implementation of the Common Language Infrastructure until being replaced by the cross-platform .NET project.",
            dotNetUsedForTitle: "What is .NET is used for?",
            dotNetUsedForText:
              ".NET is a free, cross-platform, open source developer platform for building many different types of applications. With .NET, you can use multiple languages, editors, and libraries to build for web, mobile, desktop, games, and IoT.",
            dotNetPogrammingLanguageTitle: "Is .NET a programming language?",
            dotNetPogrammingLanguageText:
              "NET Framework is a platform for building software. It is not a language itself. The primary (but not only) languages developers use to build software on the .NET Framework are C# and Visual Basic.",
            dotNetEasyToLearnTitle: "Is .NET easy to learn?",
            dotNetEasyToLearnText:
              ".NET is a local framework included in Windows. Also, many programmers find building web applications in .NET easier as compared to Java.",
            databaseTitle: "Database",
            databaseGeneral:
              "In computing, a database is an organized collection of data stored and accessed electronically. Small databases can be stored on a file system, while large databases are hosted on computer clusters or cloud storage.",
            databaseSQLServerTitle: "Microsoft SQL Server",
            databaseSQLServerText:
              "Microsoft SQL Server is a relational database management system developed by Microsoft. As a database server, it is a software product with the primary function of storing and retrieving data as requested by other software applications—which may run either on the same computer or on another computer across a network.",
            databasePostgreSQLTitle: "PostgreSQL",
            databasePostgreSQLText:
              "PostgreSQL, also known as Postgres, is a free and open-source relational database management system emphasizing extensibility and SQL compliance. It was originally named POSTGRES, referring to its origins as a successor to the Ingres database developed at the University of California",
            databaseCosmoDBTitle: "Cosmos DB",
            databaseCosmoDBText:
              "Azure Cosmos DB is Microsoft's proprietary globally distributed, multi-model database service for managing data at planet-scale launched in May 2017. It is schema-agnostic, horizontally scalable, and generally classified as a NoSQL database.",
            databaseMongoDBTitle: "MongoDB",
            databaseMongoDBText:
              "MongoDB is a source-available cross-platform document-oriented database program. Classified as a NoSQL database program, MongoDB uses JSON-like documents with optional schemas. MongoDB is developed by MongoDB Inc. and licensed under the Server Side Public License.",
            contact: "Contact Us",
            contactAddress: "Address:",
            contactAddressContent:
              " Serbia, Bulevar Oslobođenja 78, Novi Sad 21000",
            contactPhone: "Phone:",
            contactPhoneContent: "+381 21 300 6815",
            contactEmail: "Email:",
            contanctEmailContent: " info@midenas.rs",
            midenasDesignGallery: "Midenas Design Gallery",
            whyUs: "Why us?",
            whyUsContent1:
              "We have highly skilled engineers with excellent technical knowledge and experience in using latest software standards, tools, platforms, frameworks and technologies and we invest continuously in training and education, to be able to respond to any new technology challenges and demands from our clients.",
            whyUsContent2:
              "We are a reliable partner, managing dedicated nearshore teams for software development. This experience is illustrated by a large portfolio of successfully delivered projects.",
            whyUsContent3:
              "We are agile and ready to align based on project specificity, so our partners needs are always met with quality and best resources. We know both the art of matching people and the science of technology.",
            aboutUs: "About us",
            aboutUsContetn1:
              "Midenas provides complete digital services. From branding your company to complete web and desktop solutions. Fully adaptable to your needs.",
            aboutUsContetn2:
              "Midenas business philosophy is to assure the highest quality product, total client satisfaction, timely delivery of solutions and the best quality/price ratio found in the industry.",
            aboutUsContetn3:
              "As an IT firm, we take the perspectives of our clients and their diverse claims in software development. To help you achieve your goals, we enhance our capacities by working with various programming languages, platforms, and new technologies.",
            explore: "Explore",
            designRushTitle: "See our profile on DesignRush ",
          },

          nodeJsModal: {
            nodeJsTitle: "Node Js",
            nodeJsText1:
              "Node.js is an open-source, server-side framework that runs on JavaScript. It enables the development of scalable and fast web applications and server services. Node.js utilizes an asynchronous I/O model, allowing efficient handling of a large number of requests and simultaneous execution of operations without blocking the main thread. This makes Node.js suitable for building highly performant and reactive applications.",
            nodeJsText2:
              "One of the main advantages of Node.js is its community and rich module library. There is a vast number of modules and packages available through NPM (Node Package Manager), which facilitate development and solve common problems. Node.js can also be used to create RESTful APIs, microservices, and real-time applications.",
            nodeJsText3:
              "Node.js is also a popular choice for server-side web application development, offering the ability to use JavaScript both on the client and server side. This allows developers to share code and logic between the client and server, making maintenance and scaling of applications easier.",
          },
          javaModal: {
            javaTitle: "Java",
            javaText1:
              "Java is a high-level, object-oriented programming language used for developing a wide range of applications. It is easy to learn and has gained popularity in the industry due to its platform-independent nature.",
            javaText2:
              "One of the main advantages of Java is its rich set of libraries and frameworks that facilitate application development. These libraries provide ready-made components and tools for tasks such as database operations, graphics, network communication, and much more. This means that developers can build applications more quickly by leveraging existing solutions instead of starting from scratch.",
            javaText3:
              "Another powerful feature of Java is its support for multithreading, allowing the execution of multiple threads simultaneously. This is particularly useful in applications that require concurrent execution of multiple tasks or deal with large amounts of data.",
          },

          aboutUsPage: {
            title1: "Let us",
            title2: "introduce",
            title3: "ourself",
          },
          services: {
            title: "Check out our services below!",
            digitalMarketing: "Digital Marketing",
            websiteDevelopment: "Webiste Development",
            videography: "Videography",
            fotography: "Fotography",
            desktopApp: "Desktop App",
            seo: "Seo Optimization",
            graphicDesign: "Graphic Design",
          },
          buttons: {
            contactUs: "Contact us",
            send: "Send",
            getStarted: "Get Started",
            signUp: "Sign Up",
            logIn: "Log In",
            backToHomePage: "Back to home page",
            clear: "Clear",
            save: "Save",
            close: "Close",
          },
          slider: {
            caption: "Welcome To Midenas",
            description: "A lot of different solutions",
            getStarted: "Get Started",
            midenas: "Midenas",
          },
          header: {
            home: "Home",
            services: "Services",
            learning: "Learning",
            aboutUs: "About Midenas",
            contactUs: "Contact Us",
          },
          contactUs: {
            title: "Contact Us",
            fullName: "Full name",
            email: "Email*",
            phone: "Phone",
            message: "Message*",
            socialMedia: "Connect with us:",
            firstName: "First Name*",
            lastName: "Last Name*",
            sendMessage: "Send a Message",
            contacUsAdress: "Vase Pelagića 9, Novi Sad",
            contactUsEmail: "info@midenas.rs",
            contactUsPhone: "+381 21 303 1043",
            enterFirstName: "Enter first name",
            enterLastName: "Enter last name",
            enterEmail: "Enter email",
            enterMessage: "Enter message",
          },
          price: {
            title: "Pick Your Best Opinion",
            subtitle:
              "Listen without limits on your phone, speaker, and other devices at the most suitable option for you.",
          },
          signUp: {
            inputFullName: "Full Name",
            inputEmail: "Email",
            inputPassword: "Password",
            inputConfirmPass: "Confirm Password",
            mutedLink: "Forget your password?",
            mutedAlreadyHaveAcc: "Already have an account?",
            signUpBtn: "Sign Up",
            forgetPass: "Forget your password?",
          },
          logIn: {
            inputEmail: "Email",
            inputPassword: "Password",
            mutedLink: "Do not have account?",
            mutedAlreadyHaveAcc: "Already have an account?",
            logInBtn: "Log In",
            forgetPass: "Forget your password?",
          },
          loginPage: {
            headerLogIn: "Welcome to Midenas",
            headerLoginSubtitle: "Please log-in to continue!",
            headerSignUp: "Create Account",
            headerSignUpSubtitle: "Please sign-up to continue!",
          },
          learningPage: {
            sliderTitle: "Learn Anything Online",
            sliderPlaceholder: "Enter Keyword",
            courseName: "Name",
            courseDescription: "Description",
            courseTags: "Tags",
            courseBtn: "Delete all",
          },
          learningPageUnderConstruction: {
            underConstructionTitle: "- LEARNING -",
            underConstructionSubtitle: "UNDER CONSTRUCTION",
            backToHome: "Back to home",
          },
          smartInvoicingUnderConstruction: {
            underConstructionTitle: "Services",
            underConstructionSubtitle: "UNDER CONSTRUCTION",
            backToHome: "Back to home",
          },
          cookieConsent: {
            title:
              "We use cookies to improve your experience on our site and to show you relevant advertising",
          },
          dashboard: {
            dashboardSide: "Dashboard",
            profileSide: "Profile",
            addInvoice: "Add Document",
            addClient: "Add Client",
            settingsSide: "Settings",
            passwordSide: "Password",
            signOutSide: "Sign Out",
            template: "Template",
          },
          mainDashboard: {
            allInoviceCard: "All Invoices",
            monthInvoiceCard: "This Month",
            weekInvoiceCard: "This Week",
            listOfInvoices: "List of Invoices",
            recentInvoice: "Recent Invoice",
            viewAll: "View All",
          },
          profile: {
            informationProfile: "Information",
            emailProfile: "Email:",
            phoneProfile: "Phone:",
            invoicesProfile: "Invoices",
            recentProfile: "Recent",
          },
          smartInvoicing: {
            dashboard: "Dashboard",
            addInvoice: "Add Document",
            profile: "Profile",
            settings: "Settings",
            password: "Password",
            signOut: "Sign Out",
            addInvoiceTitle: "Add Document",
            dateOfIssue: "Date Of Issue",
            dueDate: "Due Date",
            choceADate: "Choce a Date",
            from: "From",
            client: "Client",
            no: "No",
            nameOfService: "Name Of Service",
            unitOfMeasure: "Unit Measure",
            quantity: "Quantity",
            rabat: "Rabat",
            editName: "Edit Name",
            invoiceNumber: "Invoice Number",
            serviceDescription: "Service Description",
            editInvoiceNumber: "Edit Invoice Number",
            manageTheColumns: "Manage the columns",
            manageTableData: "Manage table data",
            pdv: "PDV",
            price: "Price",
            menageDocumentType: "Menage document type",
          },
          passwordChange: {
            passwordChangeTitle: "Password Change",
            updatePassword: "Update Password Here",
            oldPassword: "Old Password",
            newPassword: "New Password",
            confirmPassword: "Confirm Password",
          },
          profilePage: {
            information: "Information",
            firstName: "First Name:",
            email: "Email:",
            lastName: "Last Name:",
            phone: "Phone:",
          },
          invoiceRows: {
            addRow: "Add new row",
            rabatPercent: "(%)",
          },
          invoiceComment: {
            addNewComment: "Add New Comment",
            commentTitle: "Comment Title",
            commentDescription: "Comment Description",
            comment: "Comment",
          },
          invoiceNote: {
            addNewNote: "Add New Note",
            noteTitle: "Note Title",
            noteDescription: "Note Description",
            note: "Note",
          },
          columnsModal: {
            manageColumns: "Manage The Columns",
            nameOfService: "Name Of Service",
            serviceDescription: "Service Description",
            unitOfMeasure: "Unit Measure",
            quanity: "Quanity",
            rabat: "Rabat",
          },
          menageTableAccordion: {
            nameOfService: "Name Of Service",
            serviceDescription: "Service Description",
            unitOfMeasure: "Unit Measure",
            title: "Title",
            description: "Description",
          },
          addClient: {
            addClientTitle: "Add Client",
            companyName: "Company Name",
            pib: "Tax ID",
            id: "ID Number",
            serviceId: "Service ID",
            documentLanguage: "Document Language",
            currency: "Currency",
            city: "City",
            street: "Street",
            number: "Number",
            postalCode: "Postal Code",
          },
          placeholder: {
            chooseClient: "Choose a client...",
            chooseServiceName: "Choose a service...",
            chooseServiceDescription: "Choose a description...",
            chooseNote: "Choose a note...",
            chooseComment: "Choose a comment...",
            chooseLanguage: "Choose a language...",
            chooseCurrency: "Choose a currency...",
            chooseCity: "Choose a city...",
            documentType: "Document type",
          },
          emailValidation: {
            invalid: "Enter valid Email",
            required: "Enter full name",
          },
          snackbar: {
            successMessage: "You have successfully sent the message!",
          },
          outsourcingServices: {
            outsourcingTitle: "OutSourcing",
            outsourcingDesc1:
              "Outsourcing is a business practice in which services or job functions are farmed out to a third party. In information technology, an outsourcing initiative with a technology provider can involve a range of \n operations, from the entirety of the IT function to discrete, easily defined components, such as disaster recovery, network services, software development or QA testing.",
            outsourcingDesc2:
              "Companies may choose to outsource IT services onshore (within their own country), nearshore (to a neighboring country or one in the same time zone), or offshore (to a more distant country).",
            outsourcingDesc3:
              "The company usually funds the establishment of special outsourcing agencies. The company is transferring employees who have worked in-house to these agencies. In addition to the establishment, the \n company also provides a guarantee for 1 to 2 years of secure work to the outsourcing agency under preferential terms (guaranteed price, guaranteed amount of work, etc.). In the next 1-2 years, the \n outsourcing agency is trying to find its way on the market and to develop.",
            howOutsourcingTitle: "How outSourcing works?",
            howOutsourcingDesc1:
              "For a company to effectively outsource responsibilities, it is important to focus on the business partnership as much the logistics. Outsourcing is about managing relationship more than service-level \n agreements, and is a partnership, not a purchasing project. Maintaining and securing a trusted relationship is essential in outsourcing efforts and is more complex than establishing service levels \n and relationships.",
            howOutsourcingDesc2:
              "Some experts recommend placing extra emphasis on the exit clause of a service contract. It is important for companies to know when the contractual agreement inevitably times out and ensure that the \n involved parties fulfill their obligations and stick around until the contract is up.",
            fourStepTitle: "Four - Step Action Plan",
            stepOne: "You Ask",
            stepTwo: "Candidates\napproval",
            stepThree: "Engagements\nsetup",
            stepFour: "You Get!",
          },
        },
      },
      rs: {
        translation: {
          footer: {
            subscriptionHeading: "Kontaktirajte nas za saradnju",
            inputPlaceholder: "Vaš Email",
            aboutUs: "O nama",
            contactUs: "Kontakt",
            videos: "Video",
            socialMedia: "Društvene Mreže",
            howItWorks: "Kako Funkcioniše?",
            testimonials: "Svedočenja",
            careers: "Karijera",
            investors: "Investitori",
            termsOfService: "Uslovi Korišćenja",
            contact: "Kontakt",
            support: "Podrška",
            destinations: "Destinacija",
            sponsorships: "Sponzorstvo",
            submitVideo: "Pošalji Video",
            ammbassadors: "Ambasador",
            agency: "Agencija",
            influencer: "Influencer",
            instagram: "Instagram",
            facebook: "Facebook",
            linkedin: "LinkedIn",
            twitter: "Twitter",
            websiteRights: "Design by MIDENAS © 2022",
          },
          cards: {
            cardClientTitle: "Klijent na prvom mestu",
            cardClientShort:
              "U svakom poslu klijenti su uvek u srži. Budući da smo vodeći programeri web i mobilnih aplikacija, naš koncept nadilazi naše direktne klijente.",
            cardClientDesc:
              "U svakom poslu klijenti su uvek u srži. Budući da smo vodeći programeri web i mobilnih aplikacija, naš koncept nadilazi naše direktne klijente. Sa svojim idejama uvek krećemo od mesta gde ste i razmišljamo iz ugla vaših krajnjih korisnika.",
            cardStrongExpertiseTitle: "Jaka stručnost",
            cardStrongExpertiseShort:
              "Dakle, možete očekivati veći nivo vlasništva, obaveza i isporuka u kraćem vremenu uz veći kvalitet, prateći sve najbolje prakse za razvoj.",
            cardStrongExpertiseDesc:
              "Dakle, možete očekivati veći nivo vlasništva, obaveza i isporuka u kraćem vremenu uz veći kvalitet, prateći sve najbolje prakse za razvoj. Time pružamo najbolje vrednosti za naše klijente. Uvek verujemo u Kvalitet > Količina i Vrednost je ono što se ceni.",
            cardDeliveryOnTimeTitle: "Isporuka na vreme",
            cardDeliveryOnTimeShort:
              "Imamo sjajnu kolekciju internih okvira s najboljom infrastrukturom u klasi s decenijskim iskustvom u industriji razvoja IT softvera.",
            cardDeliveryOnTimeDesc:
              "Imamo sjajnu kolekciju internih okvira s najboljom infrastrukturom u klasi s decenijskim iskustvom u industriji razvoja IT softvera koje nam pomaže u pružanju rešenja vrhunskog kvaliteta u svakom trenutku. Naučili smo kako izbeći greške i ponoviti uspeh svih ovih godina. Ne hvalimo se samo doslednošću. S vremenom to opisujemo i proizvodimo. Naši proizvodi su ovde kako bi obavestili isto.",
            showMore: "Prikaži više",
          },
          homePage: {
            technologyExpirience: "Iskustvo sa tehnologijama",
            javaScript: "JavaScript",
            java: "Java",
            typeScript: "TypeScript",
            react: "React",
            webServices: "Web Servisi",
            webApplication: "Web Aplikacije",
            webDesign: "Web Dizajn",
            customSoftware: "Prilagođen Softver",
            angular: "Angular",
            design: "Dizajn",
            cSharp: "C#",
            dotNet: ".NET",
            nodeJs: "Node.js",
            database: "Baza Podataka",
            reactTitle: "React",
            reactGeneral:
              "React je besplatna JavaScript biblioteka otvorenog koda za izgradnju korisničkih interfejsa zasnovanih na komponentama korisničkog interfejsa. Održavaju ga Meta i zajednica pojedinačnih programera i kompanija.",
            reactUsedForTitle: "Za šta se koristi React?",
            reactUsedForText:
              "React.js je JavaScript biblioteka otvorenog koda koja se koristi za izgradnju korisničkih interfejsa posebno za aplikacije na jednoj stranici. Koristi se za rukovanje slojem prikaza za web i mobilne aplikacije. React nam takođe omogućava stvaranje višekratnih UI komponenti.",
            reactProgrammingTitle: "Šta je React u programiranju?",
            reactProgrammingText:
              "React je deklarativna, efikasna i fleksibilna JavaScript biblioteka za izgradnju korisničkih interfejsa. Omogućava vam sastavljanje složenih korisničkih interfejsa od malih i izolovanih delova koda zvanih komponente.",
            javaScriptTitle: "JavaScript",
            javaScriptGeneral:
              "JavaScript, često skraćeno JS, je programski jezik koji je jedna od osnovnih tehnologija World Wide Web-a, pored HTML-a i CSS-a. Preko 97% web lokacija koristi JavaScript na strani klijenta za ponašanje web stranica, često uključujući biblioteke trećih strana",
            javaScriptUsedForTitle: "Za šta se koristi JavaScript?",
            javaScriptUsedForText:
              "JavaScript koriste programeri širom sveta za kreiranje dinamičnog i interaktivnog web sadržaja poput aplikacija i pretraživača. JS je toliko popularan da je najčešće korišćeni programski jezik na svetu, koji se kao programski jezik na strani klijenata koristi na 97,0% svih web lokacija.",
            javaScriptEasyToLearnTitle:
              "Da li je JavaScript jednostavan za naučiti?",
            javaScriptEasyToLearnText:
              "JavaScript je jednostavan i lak za učenje u poređenju sa drugim jezicima kao što su C++, Ruby i Python. To je jezik visoke razine, interpretiran koji se lako može ugraditi u jezike poput HTML-a.",
            typeScriptTitle: "TypeScript",
            typeScriptGeneral:
              "TypeScript je programski jezik koji je razvio i održava Microsoft. To je strogi sintaktički nadskup JavaScript-a i jeziku dodaje neobavezno statičko kucanje. Dizajniran je za razvoj velikih aplikacija i prenosi se na JavaScript.",
            typeScriptUsedForTitle: "Za šta se koristi TypeScript?",
            typeScriptUsedForText:
              "TypeScript pojednostavljuje JavaScript kod, čineći ga lakšim za čitanje i otklanjanje pogrešaka. TypeScript je otvoreni izvor. TypeScript pruža vrlo produktivne razvojne alate za JavaScript IDE i prakse, poput statičke provere. TypeScript olakšava čitanje i razumevanje koda.",
            typeScriptFrontOrBackTitle:
              "Da li je TypeScript frontend ili backend?",
            typeScriptFrontOrBackText:
              "TypeScript je prirodno prikladan za svet frontend aplikacija. Sa svojom bogatom podrškom za JSX i sposobnošću sigurnog modeliranja promenjivosti, TypeScript daje strukturu i sigurnost vašoj aplikaciji i tako olakšava pisanje ispravnog koda koji se može održavati u brzom okruženju koje je razvoj frontenda.",
            webServicesTitle: "Web Servisi",
            webServicesGeneral:
              "Web servisi su metode komunikacije između dva električna uređaja putem mreže. To je softverska funkcija koja se pruža na mrežnoj adresi preko weba s uslugom koja je uvek uključena kao u konceptu pomoćnog rada na računaru. Mnoge organizacije koriste više softverskih uređaja za upravljanje.",
            webServicesIsGoogleWebServiceTitle: "Da li je Google Web servis?",
            webServicesIsGoogleWebServiceText:
              "Google.com je poznati Web pretraživač. Google je učinio dostupnom Web uslugu koja omogućava programerima da se povezuju sa svojim pretraživačem u okviru sopstvenih aplikacija. Korisnik može da traži bilo koju temu na Web-u. Upit će vratiti podatke o pronađenim Web stranicama.",
            webServicesWhichLanguageTitle:
              "Koji jezik je najbolji za Web usluge?",
            webServicesWhichLanguageText:
              "JavaScript. Nema sumnje da je JavaScript kralj web razvoja i verovatno najpopularniji jezik među web programerima. To je ujedno i jedini jezik koji vam omogućava izradu web aplikacija, kako frontenda, tako i backenda, kao i mobilnih aplikacija (React Native).",
            webApplicationTitle: "Web Aplikacije",
            webApplicationExampleTitle: "Koji je primer Web Aplikacije?",
            webApplicationExampleText:
              "Popularne aplikacije uključujući Google Apps i Microsoft365. Google Apps for work sadrži Gmail, Google Docs, Google Sheets, Google Slides, skladište na mreži i još mnogo toga. Ostale funkcionalnosti uključuju deljenje dokumenata i kalendara na mreži.",
            webApplicationBegginersTitle: "Šta je web aplikacija za početnike?",
            webApplicationBegginersText:
              "Web aplikacija je aplikacija koja je razvijena korišćenjem web tehnologija. Obično se izvršava u web pregledaču odlaskom na određeni URL. Kažem da se obično izvršava jer u nekim slučajevima programeri koriste omote.",
            webApplicationYouTubeTitle: "Da li je YouTube web aplikacija?",
            webApplicationYouTubeText:
              "Web aplikacije su web stranice s funkcionalnošću i interaktivnim elementima. Gmail, Facebook, YouTube, Twitter itd. sve su web-aplikacije koje su dinamične i napravljene za angažman korisnika.",
            webDesignTitle: "Web Dizajn",
            webDesignWhatDesignerBeginnerDoTitle: "Šta radi web dizajner?",
            webDesignWhatDesignerBeginnerDoText:
              "Web dizajner kreira izgled i dizajn web stranice. Jednostavnim rečima, dizajner web stranice čini da stranica izgleda dobro. Za izradu vizualnih elemenata koriste dizajnerske programe",
            webDesignWhatDesignerDoTitle: "Šta radi web dizajner?",
            webDesignWhatDesignerDoText:
              "Web dizajner kreira izgled i dizajn web stranice. Jednostavnim rečima, dizajner web stranice čini da stranica izgleda dobro. Za izradu vizualnih elemenata koriste dizajnerske programe.",
            webDesignHowFastLearnTitle:
              "Koliko brzo možete naučiti web dizajn?",
            webDesignHowFastLearnText:
              "Potrebno je oko 5 do 6 meseci da se nauči web razvoj od nule. Ovo je ako svaki dan provedete nekoliko sati učeći. Neki ljudi nauče za samo nekoliko meseci. Međutim, drugima treba nešto više od godinu dana.",
            customSoftwareTitle: "Prilagođeni Softver",
            customSoftwareGeneral:
              "Razvoj softvera po narudžbini je proces projektovanja, stvaranja, implementacije i održavanja softvera za određeni skup korisnika, funkcija ili organizacija. Za razliku od komercijalnog gotovog softvera (COTS), razvoj softvera po narudžbi ima za cilj usko definisan skup zahteva.",
            customSoftwareImportanceTitle:
              "Koja je važnost prilagođenog softvera?",
            customSoftwareImportanceText:
              "Prilagođeni softver se prilagođava samo vašim potrebama – ni manje ni više. Smanjuje vreme i troškove obuke. Prilagođena rešenja mogu ubrzati implementaciju, kao i usvajanje korisnika. Može popuniti nišu i optimizovati vaš poslovni tok, umesto da vas prisiljava na promenu procesa koje već koristite.",
            angularTitle: "Angular",
            angularGeneral:
              "Angular je besplatni okvir web-aplikacije otvorenog koda koji se temelji na TypeScript-u koji vodi tim za Angular u Google-u i zajednica pojedinaca i korporacija. Angular je potpuni prepis istog tima koji je izgradio AngularJS.",
            angularUsedForTitle: "Za šta se koristi Angular?",
            angularUsedForText:
              "Angular je platforma i okvir za izgradnju klijentskih aplikacija na jednoj stranici koristeći HTML i TypeScript. Angular je napisan u TypeScript-u. Implementira osnovnu i izbornu funkcionalnost kao skup TypeScript biblioteka koje uvozite u svoje aplikacije.",
            angularFrontOrBackTitle: "Da li je Angular frontend ili backend?",
            angularFrontOrBackText:
              "Angular je frontend framework otvorenog koda. To je razvojni jezik TypeScript temeljen na JavaScriptu koji eliminiše nepotrebne karakteristike i kod kako bi se osigurale lakše i brže aplikacije.",
            angularEasyToLearnTitle: "Da li je Angular lako naučiti?",
            angularEasyToLearnText:
              "AngularJS je savršen za aplikacije na jednoj stranici (SPA). AngularJS je lako naučiti.",
            designTitle: "Dizajn",
            designEasyTitle: "Da li je grafički dizajn lak za naučiti?",
            designEasyText:
              "Učenje grafičkog dizajna nije teško, ali zahteva kreativno razmišljanje, sklonost umetnosti i dizajnu, te vreme i predanost. Grafički dizajn zahteva učenje potrebnih alata, kao i razumevanje i primenu principa i teorija dizajna.",
            designWhatDesignerDoTitle: "Šta rade grafički dizajneri?",
            designWhatDesignerDoText:
              "Grafički dizajneri stvaraju vizualne koncepte, koristeći računarski softver ili ručno, kako bi preneli ideje koje inspirišu, informišu i osvajaju potrošače. Oni razvijaju celokupni izgled i proizvodni dizajn za aplikacije kao što su reklame, brošure, časopisi i izveštaji.",
            cSharpTitle: "C#",
            cSharpGeneral:
              "C# je programski jezik opšte namene s više paradigmi. C# obuhvata statično kucanje, jako kucanje, leksički obim, imperativne, deklarativne, funkcionalne, generičke, objektno orijentirane i komponentno orijentirane discipline programiranja.",
            cSharSimilarJavaTitle: "Da li je C# sličan Javi?",
            cSharSimilarJavaText:
              "C# i Java slični su jezici koji se kucaju statično, snažno i očito. Oba su objektno orijentirana i dizajnirana s polu-interpretacijom ili kompilacijom u vreme izvođenja, a oba su jezici s vitičastim zagradama, poput C i C++.",
            cSharWhatPayMoreTitle: "Da li je plaćeniji Java ili C#?",
            cSharWhatPayMoreText:
              "Ista metodologija primijenjena na Indeed.com/USA pokazuje da 60% Java poslova plaća 100.000 USD ili više u poređenju sa 46,5% za C#.",
            cSharDifficultTitle: "Da li je C# teško naučiti?",
            cSharDifficultText:
              "C# je jedan od najlakših programskih jezika za učenje. C# je programski jezik opšte namene visoke razine koji je jednostavan za čitanje zbog svoje dobro definisane hijerarhije klasa. To je savršen jezik za programere početnike jer će biti jednostavan za razumevanje u poređenju s većinom drugih jezika.",
            dotNetTitle: ".NET",
            dotNetGeneral:
              ".NET Framework je vlasnički softverski okvir koji je razvio Microsoft koji prvenstveno radi na Microsoft Windows-u. To je bila dominantna implementacija zajedničke jezične infrastrukture sve dok je nije zamenio .NET projekat na više platformi.",
            dotNetUsedForTitle: "Za šta se koristi .NET?",
            dotNetUsedForText:
              ".NET je besplatna platforma za razvojne programere na više platformi otvorenog koda za izradu mnogo različitih vrsta aplikacija. Sa .NET, možete koristiti više jezika, uređivača i biblioteka za izradu za web, mobilne, desktop računara, igre i IoT.",
            dotNetPogrammingLanguageTitle: "Da li je .NET programski jezik?",
            dotNetPogrammingLanguageText:
              ".NET Framework je platforma za izradu softvera. To nije sam jezik. Primarni (ali ne samo) jezici koje programeri koriste za izradu softvera na .NET Frameworku su C# i Visual Basic.",
            dotNetEasyToLearnTitle: "Da li je lako naučiti .NET?",
            dotNetEasyToLearnText:
              ".NET je lokalni okvir uključen u Windows. Takođe, mnogi programeri pronalaze izradu web aplikacija u .NET lakši u poređenju s Javom.",
            databaseTitle: "Baza podataka",
            databaseGeneral:
              "U računarstvu, baza podataka je organizovana zbirka podataka koji se čuvaju i kojima se pristupa elektronički. Male baze podataka mogu se sačuvati u sistemu dadoteka, dok su velike baze podataka smeštene na računarskim klasterima ili skladištu u oblaku.",
            databaseSQLServerTitle: "Microsoft SQL Server",
            databaseSQLServerText:
              "Microsoft SQL Server je sistem za upravljanje relacionim bazama podataka koji je razvio Microsoft. Kao server baze podataka, to je softverski proizvod s primarnom funkcijom čuvanja i preuzimanja podataka prema zahtevima drugih softverskih aplikacija — koje mogu raditi na istom računaru ili na drugom računaru preko mreže.",
            databasePostgreSQLTitle: "PostgreSQL",
            databasePostgreSQLText:
              "PostgreSQL, također poznat kao Postgres, besplatan je sistem za upravljanje relacionim bazama podataka otvorenog koda koji naglašava proširivost i usklađenost sa SQL-om. Izvorno je nazvan POSTGRES, upućujući na svoje poreklo kao naslednik baze podataka Ingres razvijene na univerzitetu u Kaliforniji",
            databaseCosmoDBTitle: "Cosmos DB",
            databaseCosmoDBText:
              "Azure Cosmos DB je Microsoftova vlasnička globalno distribuirana, multimodelna usluga baze podataka za upravljanje podacima na planetarnom nivou pokrenuta u maju 2017. Neovisno o shemi, horizontalno skalabilna i generalno klasifikovana kao NoSQL baza podataka.",
            databaseMongoDBTitle: "MongoDB",
            databaseMongoDBText:
              "MongoDB je izvorno dostupan program baze podataka na više platformi orijentisan na dokumente. Klasifikovan kao NoSQL program baze podataka, MongoDB koristi dokumente slične JSON-u s izbornim shemama. MongoDB je razvio MongoDB Inc. i licenciran je pod javnom licencom na strani servera.",
            contact: "Kontaktirajte nas",
            contactAddress: "Adresa: ",
            contactAddressContent:
              "Srbija, Bulevar Oslobođenja 78, Novi Sad 21000",
            contactPhone: "Telefon:",
            contactPhoneContent: " +381 21 303 1043, +381 21 300 6815",
            contactEmail: "Email:",
            contanctEmailContent: " info@midenas.rs",
            midenasDesignGallery: "Galerija Dizajna Midenas",
            whyUs: "Zašto baš mi?",
            whyUsContent1:
              "Imamo visokokvalifikovane inženjere s izvrsnim tehničkim znanjem i iskustvom u korištenju najnovijih softverskih standarda, alata, platformi, okvira i tehnologija te kontinuirano ulažemo u obuku i obrazovanje kako bismo mogli odgovoriti na sve nove tehnološke izazove i zahteve naših klijenata.",
            whyUsContent2:
              "Pouzdan smo partner, upravljajući posvećenim timovima za razvoj softvera. Ovo iskustvo ilustruje veliki portfolio uspešno realizovanih projekata.",
            whyUsContent3:
              "Agilni smo i spremni za usklađivanje na temelju specifičnosti projekta, tako da se potrebe naših partnera uvek zadovoljavaju kvalitetom i najboljim resursima. Poznajemo i umetnost spajanja ljudi i nauku tehnologije.",
            aboutUs: "O nama",
            aboutUsContetn1:
              "Midenas pruža kompletne digitalne usluge. Od brendiranja Vašeg preduzeća do kompletnog kako web tako i desktop rešenja. Potpuno prilagodljivo Vašim potrebama.",
            aboutUsContetn2:
              "Poslovna filozofija kompanije Midenas je da obezbedi najviši kvalitet proizvoda, potpuno zadovoljstvo klijenata, pravovremenu isporuku rešenja i najbolji odnos kvaliteta i cene u industriji.",
            aboutUsContetn3:
              "Kao IT kompanija, uzimamo u obzir perspektive naših klijenata i njihove različite zahteve u razvoju softvera. Kako bismo vam pomogli da postignete svoje ciljeve, poboljšavamo svoje kapacitete radeći s različitim programskim jezicima, platformama i novim tehnologijama.",
            explore: "Istražite",
            designRushTitle: "Pogledajte naš profil na DesignRush",
          },
          nodeJsModal: {
            nodeJsTitle: "Node.js",
            nodeJsText1:
              "Node.js je otvorenokodni serverski okvir koji se izvršava na JavaScriptu. Omogućava razvoj skalabilnih i brzih veb aplikacija i serverskih servisa. Node.js koristi asinhroni I/O model, što omogućava efikasno rukovanje velikim brojem zahteva i istovremeno izvršavanje operacija bez blokiranja glavnog procesa. To čini Node.js pogodnim za izgradnju visoko performantnih i reaktivnih aplikacija.",
            nodeJsText2:
              "Jedna od glavnih prednosti Node.js-a je njegova zajednica i bogata biblioteka modula. Postoji veliki broj modula i paketa dostupnih putem NPM (Node Package Manager), koji olakšavaju razvoj i rešavaju uobičajene probleme. Node.js se takođe može koristiti za kreiranje RESTful API-ja, mikroservisa i aplikacija u realnom vremenu.",
            nodeJsText3:
              "Node.js je takođe popularan izbor za razvoj serverskih veb aplikacija, pružajući mogućnost korišćenja JavaScripta i na klijentskoj i na serverskoj strani. To omogućava programerima da dele kod i logiku između klijenta i servera, olakšavajući održavanje i skaliranje aplikacija.",
          },
          javaModal: {
            javaTitle: "Java",
            javaText1:
              "Java je visokonivo, objektno orijentisan programski jezik koji se koristi za razvoj širokog spektra aplikacija. Jednostavan je za učenje i stekao je popularnost u industriji zbog svoje platformski nezavisne prirode.",
            javaText2:
              "Jedna od glavnih prednosti Java-e je njena bogata biblioteka i okviri koji olakšavaju razvoj aplikacija. Ove biblioteke pružaju gotove komponente i alate za zadatke poput operacija sa bazama podataka, grafika, komunikacije putem mreže i mnoge druge. To znači da programeri mogu brže izgraditi aplikacije koristeći postojeća rešenja umesto da kreću od nule.",
            javaText3:
              "Još jedna moćna karakteristika Java-e je podrška za višenitno izvršavanje, što omogućava izvršavanje više niti istovremeno. Ovo je posebno korisno u aplikacijama koje zahtevaju istovremeno izvršavanje više zadataka ili se bave velikim količinama podataka.",
          },
          aboutUsPage: {
            title1: "Dozvolite",
            title2: "da se",
            title3: "predstavimo",
          },
          services: {
            title: "Pogledajte naše usluge!",
            digitalMarketing: "Digitalni Marketing",
            websiteDevelopment: "Webiste Development",
            videography: "Video",
            fotography: "Fotografija",
            desktopApp: "Desktop Aplikacija",
            seo: "Seo Optimizacija",
            graphicDesign: "Graficki Dizajn",
          },
          buttons: {
            contactUs: "Kontaktirajte nas",
            send: "Pošalji",
            getStarted: "Počni",
            signUp: "Registruj se",
            backToHomePage: "Vratite se na početnu stranicu",
            clear: "Očisti",
            save: "Sačuvaj",
            close: "Zatvori",
          },
          slider: {
            caption: "Dobrodošli u Midenas",
            description: "Mnogo različitih solucija",
            getStarted: "Počni",
            midenas: "Midenas",
          },
          header: {
            home: "Početna",
            services: "Usluge",
            learning: "Kursevi",
            aboutUs: "O Nama",
            contactUs: "Kontaktirajte nas",
          },
          contactUs: {
            title: "Kontaktirajte nas",
            firstName: "Ime*",
            lastName: "Prezime*",
            email: "Email*",
            phone: "Telefon",
            message: "Poruka*",
            socialMedia: "Povežite se s nama:",
            letsGetInTouch: "Kontaktirajte nas",
            sendMessage: "Pošaljite Poruku",
            enterFirstName: "Unesite ime",
            enterLastName: "Unesite prezime",
            enterEmail: "Unesite email",
            enterMessage: "Unesite poruku",
          },
          price: {
            title: "Izaberite Ponudu",
            subtitle:
              "Slušajte bez ograničenja na svom telefonu, zvučniku i drugim uređajima.",
          },
          signUp: {
            inputFullName: "Ime i Prezime",
            inputEmail: "Email",
            inputPassword: "Lozinka",
            inputConfirmPass: "Potvrdite Lozinku",
            forgetPass: "Zaboravili ste lozinku?",
            mutedAlreadyHaveAcc: "Imate nalog?",
            signUpBtn: "Registrujte Se",
          },
          logIn: {
            inputEmail: "Email",
            inputPassword: "Lozinka",
            mutedLink: "Nemate nalog?",
            mutedAlreadyHaveAcc: "Već imate nalog?",
            logInBtn: "Ulogujte Se",
            forgetPass: "Zaboravili ste lozinku?",
          },
          loginPage: {
            headerLogIn: "Dobrodošli U Midenas",
            headerLoginSubtitle: "Ulogujte se da nastavite!",
            headerSignUp: "Napravite Nalog",
            headerSignUpSubtitle: "Registrujte se da nastavite!",
          },
          learningPage: {
            sliderTitle: "Naučite Sve Online",
            sliderPlaceholder: "Unesite Reč",
            courseName: "Ime",
            courseDescription: "Opis",
            courseTags: "Tagovi",
            courseBtn: "Obriši sve",
          },
          learningPageUnderConstruction: {
            underConstructionTitle: "- KURSEVI -",
            underConstructionSubtitle: "U IZRADI",
            backToHome: "Povratak na početnu",
          },
          smartInvoicingUnderConstruction: {
            underConstructionTitle: "Usluge",
            underConstructionSubtitle: "U IZRADI",
            backToHome: "Povratak na početnu",
          },
          cookieConsent: {
            title:
              "Koristimo kolačiće da poboljšamo vaše iskustvo na našoj web stranici i da Vam prikažemo relevantno oglašavanje",
          },
          dashboard: {
            dashboardSide: "Kontrolna tabla",
            addInvoice: "Dodaj Dokument",
            addClient: "Dodaj Klijenta",
            profileSide: "Profil",
            settingsSide: "Podešavanja",
            passwordSide: "Lozinka",
            signOutSide: "Odjavi se",
            template: "Šablon",
          },
          mainDashboard: {
            allInoviceCard: "Sve Fakture",
            monthInvoiceCard: "Ovog Meseca",
            weekInvoiceCard: "Ove Nedelje",
            listOfInvoices: "Lista Faktura",
            recentInvoice: "Poslednje Fakture",
            viewAll: "Pogledaj Sve",
          },
          profile: {
            informationProfile: "Informacije",
            emailProfile: "Email:",
            phoneProfile: "Telefon:",
            invoicesProfile: "Fakture",
            recentProfile: "Recent",
          },
          smartInvoicing: {
            dashboard: "Kontrolna Tabla",
            addInvoice: "Dodaj Dokument",
            profile: "Profil",
            settings: "Podešavanja",
            password: "Lozinka",
            signOut: "Odjavi Se",
            addInvoiceTitle: "Dodaj Fakturu",
            dateOfIssue: "Datum Izdavanja",
            dueDate: "Rok Predaje",
            choseADate: "Izaberite Datum",
            from: "Od",
            client: "Klijent",
            no: "Br.",
            nameOfService: "Naziv Usluge",
            unitOfMeasure: "Jedinica Mere",
            quantity: "Količina",
            rabat: "Rabat",
            editName: "Uredi Ime",
            invoiceNumber: "Broj Fakture",
            serviceDescription: "Opis Usluge",
            editInvoiceNumber: "Uredi broj fakture",
            manageTheColumns: "Upravljajte kolonama",
            manageTableData: "Upravljajte podacima tabele",
            pdv: "PDV",
            price: "Cena",
            menageDocumentType: "Upravljaj tipovima dokumenata",
          },
          passwordChange: {
            passwordChangeTitle: "Promena Lozinke",
            updatePassword: "Ažurirajte Lozinku Ovde",
            oldPassword: "Stara Lozinka",
            newPassword: "Nova Lozinka",
            confirmPassword: "Potvrdite Lozinku",
          },
          profilePage: {
            information: "Informacije",
            firstName: "Ime:",
            email: "Email:",
            lastName: "Prezime:",
            phone: "Telefon:",
          },
          invoiceRows: {
            addRow: "Dodaj novi red",
            rabatPercent: "(%)",
          },
          invoiceComment: {
            addNewComment: "Dodaj Novi Komentar",
            commentTitle: "Naslov Komentara",
            commentDescription: "Opis Komentara",
            comment: "Komentar",
          },
          invoiceNote: {
            addNewNote: "Dodaj Nove Beleške",
            noteTitle: "Naslov Beleške",
            noteDescription: "Opis Beleške",
            note: "Beleške",
          },
          columnsModal: {
            manageColumns: "Upravljajte Kolonama",
            nameOfService: "Naziv Usluge",
            serviceDescription: "Opis Servisa",
            unitOfMeasure: "Jedinica Mere",
            quanity: "Količina",
            rabat: "Rabat",
          },
          menageTableAccordion: {
            nameOfService: "Naziv Usluge",
            serviceDescription: "Opis Servisa",
            unitOfMeasure: "Jedinica Mere",
            title: "Naslov",
            description: "Opis",
          },
          addClient: {
            addClient: "Dodaj Klijenta",
            companyName: "Naziv Kompanije",
            pib: "PIB",
            id: "JMBG",
            serviceId: "Servisni ID",
            documentLanguage: "Jezik Dokumenta",
            currency: "Valuta",
            city: "Grad",
            street: "Ulica",
            number: "Broj",
            postalCode: "Poštanski Broj",
          },
          placeholder: {
            chooseClient: "Izaberite klijenta...",
            chooseServiceName: "Izaberite uslugu...",
            chooseServiceDescription: "Izaberite opis...",
            chooseNote: "Izaberite belešku...",
            chooseComment: "Izaberite komentar...",
            chooseLanguage: "Izaberite jezik...",
            chooseCurrency: "Izaberite valutu...",
            chooseCity: "Izaberite grad...",
            documentType: "Tip dokumenta",
          },
          emailValidation: {
            invalid: "Unesite ispravan Email",
            required: "Unesite ime i prezime",
          },
          snackbar: {
            successMessage: "Uspešno ste poslali poruku!",
          },
          outsourcingServices: {
            outsourcingTitle: "OutSourcing",
            outsourcingDesc1:
              "OutSourcing je poslovna praksa u kojoj se usluge ili poslovne funkcije povjeravaju trećoj strani. U informacijskoj tehnologiji, inicijativa vanjskog poslovanja s pružateljem tehnoloških usluga može uključivati\n  različite operacije, od cijele IT funkcije do diskretnih, jasno definiranih komponenti, kao što su oporavak od katastrofe, mrežne usluge, razvoj softvera ili QA testiranje.",
            outsourcingDesc2:
              "Kompanije mogu odabrati da izvode IT usluge na domaćem tržištu (u vlastitoj zemlji), u blizini (u susjednoj zemlji ili u istoj vremenskoj zoni) ili u inostranstvu (u nekoj udaljenijoj zemlji).",
            outsourcingDesc3:
              "Kompanija obično finansira osnivanje posebnih outsourcing agencija. Kompanija prebacuje zaposlene koji su radili interno u tim agencijama. Pored osnivanja, kompanija takođe obezbeđuje \n garanciju za 1 do 2 godine sigurnog posla agenciji za outsourcing pod povoljnim uslovima (garantovana cena, garantovana količina posla, itd.). U narednih 1-2 godine, agencija za outsourcing\n pokušava da pronađe svoje mesto na tržištu i razvija se.",
            howOutsourcingTitle: "Kako outsourcing funkcioniše?",
            howOutsourcingDesc1:
              "Da bi kompanija efikasno prebacila odgovornosti na outsourcing, važno je usredsrediti se na poslovno partnerstvo jednako koliko i na logistiku. OutSourcing se odnosi na upravljanje odnosima \nviše nego na nivoe usluga i predstavlja partnerstvo, a ne projekat kupovine. Održavanje i obezbeđivanje pouzdanog odnosa su ključni za uspeh vanjskog poslovanja i kompleksniji su od uspostavljanja \nnivoa usluga i odnosa.",
            howOutsourcingDesc2:
              "Neki stručnjaci preporučuju dodatni naglasak na klauzulu o raskidu u ugovoru o pružanju usluga. Važno je da kompanije znaju kada ugovor neizbežno ističe i da osiguraju da uključene strane ispune\nsvoje obaveze i ostanu prisutne dok ugovor ne istekne.",
            fourStepTitle: "Četvorostepeni akcioni plan",
            stepOne: "Vi pitate",
            stepTwo: "Odobrenje\nkandidata",
            stepThree: "Postavljanje\nangažmana",
            stepFour: "Vi dobijate!",
          },
        },
      },
    },
  });

export default i18n;
